import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "./utils";

const Slider = React.forwardRef(({ className, value, ...props }, ref) => {
  const isZero = value?.[0] === 0;

  return (
    <SliderPrimitive.Root
      ref={ref}
      value={value}
      className={cn(
        "relative flex w-full touch-none select-none items-center",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          "relative h-3 w-full grow overflow-hidden rounded-full",
          isZero ? "bg-red-200" : "bg-secondary"
        )}
      >
        <SliderPrimitive.Range
          className={cn(
            "absolute h-full",
            isZero ? "bg-red-500" : "bg-primary"
          )}
        />
      </SliderPrimitive.Track>

      <SliderPrimitive.Thumb
        className={cn(
          "block h-6 w-6 rounded-full border-2 bg-white shadow transition-colors",
          isZero ? "border-red-500" : "border-primary",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        )}
      />
    </SliderPrimitive.Root>
  );
});

Slider.displayName = "Slider";

export { Slider };
